import { EngineContext } from 'engine/components/EngineProvider';
import { Layer } from 'game/components/Layer';
import { Message, message } from 'game/components/Message';
import { Modal, ModalBody, ModalFooter } from 'game/components/Modal';
import { UIButton } from 'game/components/UIButton';
import { createStyles } from 'game/lib/createStyles';
import { colors } from 'game/styles/theme';
import { useContext, useEffect } from 'react';

const classes = createStyles({
  videoContainer: {
    width: '75%',
    border: `1px solid ${colors.grey5}`,
    margin: '0 auto',
    marginBottom: 20,
  },
  video: {
    width: '100%',
    display: 'block',
  },
});

interface EditRobotModalProps {
  onClose: () => void,
}

export const EditRobotModal: React.FC<EditRobotModalProps> = ({ onClose }) => {
  const engine = useContext(EngineContext);
  useEffect(() => {
    engine.time.timeScale = 0;
    return () => { engine.time.timeScale = 1; };
  }, [engine]);

  return (
    <Layer>
      <Modal heading={message('Reprogramming')} onClose={onClose}>
        <ModalBody>
          <p>
            <Message
              text="From here, you can reprogram a robot or machine. To change its programming, {add modules} and {wire them together}."
              values={{
                'add modules': <strong><Message text="add modules" /></strong>,
                'wire them together': <strong><Message text="wire them together" /></strong>,
              }}
            />
          </p>
          <p>
            <Message
              text="To {delete} a module or wire, right-click on it."
              values={{ delete: <strong><Message text="delete" /></strong> }}
            />
          </p>
          <div className={classes.videoContainer}>
            <video controls muted className={classes.video}>
              <source src="https://i.imgur.com/ovEg4Ti.mp4" type="video/mp4" />
            </video>
          </div>
          <ModalFooter>
            <UIButton onClick={onClose}>
              <Message text="Got it" />
            </UIButton>
          </ModalFooter>
        </ModalBody>
      </Modal>
    </Layer>
  );
};
